/**
 *
 */
export function form() {
	// voorkom dubbel initialiseren als dit script meerdere keren wordt geïmporteerd
	if (window.__gfFloatingLabelsInit) return;
	window.__gfFloatingLabelsInit = true;

	const labelClasses = ['!-translate-y-6', 'scale-75'];
	const inputSelector = '.gform_wrapper input:not(.gform_hidden), .gform_wrapper textarea:not(.gform_hidden)';
	const allowedClassNames = new Set([
		'gfield--input-type-text',
		'gfield--type-text',
		'gfield--input-type-textarea',
		'gfield--type-textarea',
		'gfield--input-type-password',
		'gfield--type-password',
		'gfield--input-type-phone',
		'gfield--type-phone',
		'gfield--input-type-email',
		'gfield--type-email',
	]);

	const isAllowedField = (input) => {
		const field = input.closest('.gfield');
		return field && [...allowedClassNames].some((c) => field.classList.contains(c));
	};

	const getLabel = (input) => {
		const field = input.closest('.gfield');
		return field ? field.querySelector('label') : null;
	};

	// 1) Initialiseer labels op basis van huidige waarden
	const initFilledStates = (root = document) => {
		root.querySelectorAll(inputSelector).forEach((input) => {
			if (!isAllowedField(input)) return;
			const label = getLabel(input);
			if (!label) return;

			if (input.value && input.value.length) {
				label.classList.add(...labelClasses);
				input.classList.add('full');
			} else {
				label.classList.remove(...labelClasses);
				input.classList.remove('full');
			}
		});
	};

	// init nu (bij eerste load)
	initFilledStates();

	// 2) Delegatie: focus/blur gedrag
	document.addEventListener('focusin', (e) => {
		const input = e.target.closest(inputSelector);
		if (!input || !isAllowedField(input)) return;
		const label = getLabel(input);
		if (label) label.classList.add(...labelClasses);
	});

	document.addEventListener('focusout', (e) => {
		const input = e.target.closest(inputSelector);
		if (!input || !isAllowedField(input)) return;
		if (!input.value || !input.value.length) {
			const label = getLabel(input);
			if (label) label.classList.remove(...labelClasses);
			input.classList.remove('full');
		} else {
			input.classList.add('full');
		}
	});

	// 3a) Re-init bij Gravity Forms jQuery events (AJAX render, multipage)
	if (window.jQuery) {
		const $ = window.jQuery;
		$(document).on('gform_post_render', (event, formId) => {
			const wrap = document.getElementById(`gform_wrapper_${formId}`) || document;
			initFilledStates(wrap);
		});
		$(document).on('gform_page_loaded', (event, formId) => {
			const wrap = document.getElementById(`gform_wrapper_${formId}`) || document;
			initFilledStates(wrap);
		});
	}

	// 3b) Fallback zonder jQuery: observeer wijzigingen binnen de wrapper(s)
	document.querySelectorAll('.gform_wrapper').forEach((wrapper) => {
		const mo = new MutationObserver((mutations) => {
			for (const m of mutations) {
				if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
					initFilledStates(wrapper);
					break;
				}
			}
		});
		mo.observe(wrapper, { childList: true, subtree: true });
	});
}
